const supportIconNames = {
    "Helpful": "mail",
    "Priority": "phone",
    "Dedicated": "user"
}

export default supportIconNames